import React from 'react';
import IconBase from './IconBase';

const SchoolStrikethroughIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M4.2,3.6C4.1,3.4,3.9,3.4,3.7,3.4c-0.2,0-0.4,0.1-0.5,0.2C3,3.7,3,3.9,3,4.1C3,4.3,3,4.5,3.2,4.6l0.6,0.6L1,9h1v10h15.5l2.2,2.2c0.2,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2c0.2-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5L4.2,3.6zM3.5,17.5V9h4l3.7,3.7c-0.4,0.3-0.7,0.7-0.7,1.3v3.5H3.5z M13.5,17.5V15l2.5,2.5H13.5z"/>
            <rect x="6" y="10" width="2" height="2"/>
            <rect x="6" y="13" width="2" height="2"/>
            <rect x="16" y="10" width="2" height="2"/>
            <polygon points="18,13 16,13 18,15 	"/>
            <path d="M13.5,9c0-0.8-0.7-1.5-1.5-1.5c-0.4,0-0.8,0.2-1.1,0.4l2.1,2.1C13.3,9.8,13.5,9.4,13.5,9z"/>
            <polygon points="22,19 22,9 23,9 20,5 13.4,5 12,3.6 10.6,5 8,5 10,7 12,5 16,9 20.5,9 20.5,17.5 		"/>
        </IconBase>
    )
}

export default SchoolStrikethroughIcon;